import { render, staticRenderFns } from "./TablaStructure.vue?vue&type=template&id=2b405651&scoped=true"
import script from "./TablaStructure.vue?vue&type=script&lang=js"
export * from "./TablaStructure.vue?vue&type=script&lang=js"
import style0 from "./TablaStructure.vue?vue&type=style&index=0&id=2b405651&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b405651",
  null
  
)

export default component.exports